var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"ma-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n        "+_vm._s(this.model.name)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }